import React, { forwardRef } from 'react';
import './Dialog.scss';

// padding note
// xs: 1 button
// s: 2 buttons

interface Props {
    children: React.ReactNode;
    hasFooter?: boolean;
}

const DialogContent = forwardRef<any, Props>(
    ({ children, hasFooter = true, ...others }, ref) => {
        return (
            <div
                className={`Dialog--contentWrapper ${
                    hasFooter ? 'has-footer' : ''
                }`}
                {...others}
                ref={ref}
            >
                {children}
            </div>
        );
    }
);

export default DialogContent;
